import React, { Component } from 'react';

import { localeStrings as strings } from 'applicationConfig';

class UserDetailsDescription extends Component {
  render() {
    return (
      <div className={`${this.props.className} `}>
        <b>{strings.myAccount.userDetailsTab.subscriptionInfo}</b>
        <p> {strings.myAccount.userDetailsTab.description1}</p>
        <p> {strings.myAccount.userDetailsTab.description2}</p>

        <p>
          <span>{strings.myAccount.emailInfo} </span>
          <a className="mailto" href={'mailto:' + strings.myAccount.infoEmailAddress}>
            {strings.myAccount.infoEmailAddress}
          </a>
        </p>
      </div>
    );
  }
}

export default UserDetailsDescription;



// WEBPACK FOOTER //
// ./src/containers/MyAccount/UserDetails/UserDetailsDescription.jsx